import { RouteConfig } from "vue-router/types/router";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";

export const meetingsRoutes = (startTemplateWithoutEventId: string, startTemplate: string): RouteConfig[] => [
    {
        path: startTemplate + '/meetings/:id',
        name: RouteNamesEnum.viewMeeting,
        component: () => import(/* webpackChunkName: "meetings" */ '../../views/MeetingView.vue'),
        meta: {
            program: true,
            analyticName: 'Meeting'
        }
    },
    {
        path: startTemplateWithoutEventId + '/meetings/:id/public',
        name: RouteNamesEnum.viewMeetingPublic,
        component: () => import(/* webpackChunkName: "meetings" */ '../../views/MeetingView.vue'),
        meta: {
            program: true,
            analyticName: 'Meeting'
        }
    },
    {
        path: startTemplate + '/appointment/:id',
        name: RouteNamesEnum.appointment,
        component: () => import(/* webpackChunkName: "meetings" */ '../../views/AppointmentView.vue'),
        meta: {
            program: true,
            analyticName: 'Appointment'
        }
    },
    {
        path: startTemplate + '/meetingsSchedule/:scheduleId?',
        name: RouteNamesEnum.meetingsSchedule,
        component: () => import(/* webpackChunkName: "meetingsSchedule" */ '../../views/MeetingsScheduleView.vue'),
        meta: {
            program: true,
            analyticName: 'Meetings schedule'
        },
    },
];
